"use client";

import React, {
  createContext,
  useContext,
  type ReactNode,
} from "react";
import { useLiveWebSocketOptional } from "@/contexts/WebSocketContext";

export type LiveData = {
  usd_price: number;
  usd_price_24h_change_percentage: number;
  usd_market_cap?: number;
  usd_24h_vol?: number;
  last_updated_at: string;
};

interface LiveDataContextType {
  liveData: LiveData | null;
  lastFetched: Date | null;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

const LiveDataContext = createContext<LiveDataContextType | undefined>(undefined);

interface LiveDataProviderProps {
  children: ReactNode;
}

export function LiveDataProvider({ children }: LiveDataProviderProps): React.ReactElement {
  const ws = useLiveWebSocketOptional();

  return (
    <LiveDataContext.Provider
      value={{
        liveData: ws?.liveData ?? null,
        lastFetched: ws?.lastUpdatedAt ?? null,
        isLoading: ws?.liveData == null,
        refetch: async () => {},
      }}
    >
      {children}
    </LiveDataContext.Provider>
  );
}

export function useLiveData(): LiveDataContextType {
  const context = useContext(LiveDataContext);
  if (context === undefined) {
    throw new Error("useLiveData must be used within a LiveDataProvider");
  }
  return context;
}
